import { MAX_SWIPE_RATIO, MIN_SWIPE_OFFSET, ONBOARDING_SWIPE_OFFSET } from '../constants';

/**
 * Предельный сдвиг сообщения при свайпе.
 *
 * Замеряется в момент начала жеста — размеры сообщения могут меняться между
 * свайпами. Сообщение уезжает максимум на долю своей ширины, чтобы часть
 * пузыря осталась на экране. Доля берётся из RS-настройки
 * chats.replies.swipeConfig (useSwipeConfig), по умолчанию MAX_SWIPE_RATIO.
 *
 * Для сообщений у правого края экрана (исходящих) доля ширины короткого пузыря
 * может оказаться меньше, чем нужно, чтобы иконка реплая справа полностью
 * выехала на экран, — поэтому их ход не опускается ниже MIN_SWIPE_OFFSET.
 * Направление определяется геометрически по left-координате (как в
 * getOnboardingSwipeOffset), без знания messageType.
 */
export const getMaxSwipeOffset = (messageElement: HTMLElement, maxSwipeRatio: number = MAX_SWIPE_RATIO): number => {
  const { left, width } = messageElement.getBoundingClientRect();
  const widthOffset = width * maxSwipeRatio;

  return left < widthOffset ? widthOffset : Math.max(widthOffset, MIN_SWIPE_OFFSET);
};

/**
 * Максимальный сдвиг для онбординга — гарантирует, что хинт остаётся на экране.
 *
 * Входящие (left-aligned): `left` минимален → 80% от ширины сообщения (getMaxSwipeOffset).
 * Исходящие (right-aligned): `left` максимален → фиксированный ONBOARDING_SWIPE_OFFSET.
 */
export const getOnboardingSwipeOffset = (messageElement: HTMLElement): number => {
  const { left } = messageElement.getBoundingClientRect();
  const maxWidthOffset = getMaxSwipeOffset(messageElement);

  return left < maxWidthOffset ? maxWidthOffset : ONBOARDING_SWIPE_OFFSET;
};
